module.exports = __webpack_public_path__ + "1.4.15-unryo/img/blue-coat.9a295dc8.svg";